import {atom} from "jotai";

// Whether the registry project's test chat drawer (TestChatDrawer) is open. Opened by the header's Start
// button and by the flow designer's START node.
export const TestChatOpenAtom = atom(false);

// The browser phone panel's open tab (calls | dial | queue), null when it is closed. Set by the header's phone
// button and the mobile bottom navigation's Phone item.
export const PhoneTabAtom = atom(null);

// Whether the browser phone panel (calls | dial | queue) is open; the mobile bottom navigation hides while it is.
export const PhonePanelOpenAtom = atom(false);
